<template>
    <dash
        icon="fa fa-money"
        titulo="RENDIMENTOS ANUAIS (DIRFs)"
        @click.native="$router.push({ name: 'Dirfs' })"
    ></dash>
</template>

<script>
import Dash from '@/shared/components/DashComponent'

export default {
	components: {
		Dash
	},

	data() {
		return {}
	}
}
</script>
